import React, { memo, useCallback } from 'react';
import { AdvancedMarker, Pin } from '@vis.gl/react-google-maps';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedEvent } from '../../store/Actions';

const MyMarkerComponent = ({event, setMarkerRef, onClick}) => {
    const userCategories = useSelector(state=>state.viewingUserCategories);
    const dispatch = useDispatch()
    const setMarker = useCallback((marker) => {
      setMarkerRef(marker, event.id)
    }, [setMarkerRef, event.id])
    const handleClick = useCallback(() => {
      if(onClick){
        onClick(event)
      } else {
        dispatch(setSelectedEvent(event))
      }
    }, [dispatch, event, onClick])
    if(!event.location)
      return null
      
    return (
      <>
        <AdvancedMarker
          onClick={handleClick}
          position={event.location.coordinates}
          ref={setMarker}
        >
          <Pin background={userCategories[event.categoryId].pinColor} borderColor={userCategories[event.categoryId].pinColor}>
            <p style={{fontSize:'16px'}}>{event.emoji}</p>
          </Pin>
        </AdvancedMarker>
      </>
    );
  };

export const MyMarker = memo(MyMarkerComponent);
